import React from 'react';

import RenderBodyCopy from '../RenderBodyCopy';
import RenderButtons from '../RenderButtons';

import addHighlight from '@src/utils/addHighlight';

import { ProductBoxPropTypes } from './ProductBox.types';

const ProductBox: React.FC<ProductBoxPropTypes> = ({
  isNew,
  product,
  className,
  buttonClassName,
  headingClassName,
  bodyCopyClassName,
  announcement,
}) => {
  const processedTitle = addHighlight(product?.title ?? '');

  return (
    <div
      className={`relative z-10 mb-[2.4rem] text-left md:rounded-[2.4rem] md:bg-background-tertiary md:p-[2.4rem] lg:max-w-[40.9rem] 2xl:mb-[0] 2xl:self-center ${className}`}
    >
      {isNew && (
        <span className='mb-[1rem] inline-block rounded-[0.7rem] bg-[#01A1FF] p-[0.5rem] text-[1.6rem] font-medium text-[#F6F6F6]'>
          {product?.preTitle}
        </span>
      )}
      {announcement && (
        <p className='mb-[2.2rem] bg-[#3D3D3D] px-[2.3rem] py-[1.4rem] text-[2rem] font-medium  leading-[3rem] tracking-[0.4rem] text-[#898989] lg:rounded-t-[2.4rem]'>
          {announcement}
        </p>
      )}
      <h2
        className={`mb-[1.6rem] text-[2.8rem] font-light uppercase leading-[1.2] tracking-[-0.056rem] lg:text-[4rem] lg:leading-[5rem] lg:tracking-[-0.08rem] [&>span]:drop-shadow-xs ${headingClassName}`}
        dangerouslySetInnerHTML={{
          __html: processedTitle,
        }}
      />

      <RenderBodyCopy
        className={`mx-0 mb-[1.7rem] max-w-[78.6rem] font-light md:mb-[2.4rem] lg:mx-auto lg:mb-[2.7rem] lg:text-[2.4rem] ${bodyCopyClassName}`}
        bodyCopy={product?.bodyCopy?.json?.content}
      />

      <RenderButtons
        className={`mt-[0] md:justify-start ${buttonClassName}`}
        items={product?.buttonCollection?.items}
      />
    </div>
  );
};

export default ProductBox;
